import React from 'react';

const TypeForm = () => {
    return (
        <div>
            <h1>TypeForm</h1>
        </div>
    );
};

export default TypeForm;
